import { ShopLandingPage } from '@screens/ShopPage/ShopLandingPage.tsx';
import { getBackgroundImageUrl } from '@utils/nutrition/getImageUrl.ts';

export const ShopPage = () => {
  return (
    <div
      data-testid="shop-page"
      className="min-h-screen bg-cover bg-center"
      style={{
        backgroundImage: `url(${getBackgroundImageUrl('ingredient_detail_background.png')})`,
      }}
    >
      <ShopLandingPage />
    </div>
  );
};
